<template>
  <v-card class="mb-4">
    <v-card-text class="pa-5">
      <h3 class="title font-weight-regular">Online</h3>
      <h6 class="subtitle-2 font-weight-light">Real-time channel status</h6>
      <v-row class="mt-3 text-center">
        <v-col cols="4">
          <v-icon>mdi-account</v-icon>
          <h2 class="mb-0 display-1 font-weight-light">{{ users }}</h2>
          <small class>User</small>
        </v-col>
        <v-col cols="4">
          <v-icon>mdi-video</v-icon>
          <h2 class="mb-0 display-1 font-weight-light">{{ contents }}</h2>
          <small class>Content</small>
        </v-col>
        <v-col cols="4">
          <v-icon>mdi-cast</v-icon>
          <h2 class="mb-0 display-1 font-weight-light">{{ lives }}</h2>
          <small class>Live</small>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "RealTimeOnline",
  props: [""],
  data: () => ({
    users: 0,
    contents: 0,
    lives: 0,
    timeId: ""
  }),
  methods: {
    async getOnlineChannel() {
      const channel_id = this.$store.state.channelId;
      const path = `/admin/getChannelOnline?channel_id=${channel_id}`;
      try {
        const data = await this.$axiosAuth.get(path);
        if (data && data.status == 200) {
          const result = data.data;
          this.users = result.visitorsCount;
          this.contents = result.viewContentCount;
          this.lives = result.viewLiveCount;
          console.log({ result });
        }
      } catch (e) {
        console.log(e);
      }

      this.timeId = setTimeout(() => {
        this.getOnlineChannel();
      }, 10000);
    }
  },
  watch: {},
  async mounted() {
    await this.getOnlineChannel();
  },
  beforeDestroy() {
    if (this.timeId) clearTimeout(this.timeId);
  }
};
</script>
<style scoped></style>
